import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement("g", { fill: "currentColor", clipPath: "url(#Analytics-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M2.733 13.083a11.67 11.67 0 0 1 11.6-10.416v11.666H2.667q0-.633.066-1.25m1.258 0a10.42 10.42 0 0 1 9.092-9.092v9.092z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M16 3.708a.625.625 0 1 0 0 1.25c6.098 0 11.042 4.944 11.042 11.042S22.098 27.042 16 27.042 4.958 22.098 4.958 16a.625.625 0 1 0-1.25 0c0 6.789 5.503 12.292 12.292 12.292S28.292 22.789 28.292 16 22.788 3.708 16 3.708" })),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "Analytics-Outlined_svg__a" }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M2.667 2.667h26.667v26.667H2.667z" })))
);
var SvgAnalyticsOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AnalyticsOutlined_default = SvgAnalyticsOutlined;

export { AnalyticsOutlined_default as default };
